"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageAbout = void 0;

var basic_frontend_common_1 = require("basic-frontend-common");

var react_1 = __importDefault(require("react"));

var react_localization_1 = __importDefault(require("react-localization"));

var json = __importStar(require("./localization.json"));

var PageAbout = function PageAbout(_a) {
  var language = _a.language,
      theme = _a.theme;
  var localizedStrings = new react_localization_1["default"](json);
  localizedStrings.setLanguage(language);
  return react_1["default"].createElement(basic_frontend_common_1.ContainerArticle, {
    theme: theme
  }, react_1["default"].createElement(basic_frontend_common_1.Intro, {
    title: localizedStrings.sharedContent.pages.pageAbout.title,
    lead: localizedStrings.sharedContent.pages.pageAbout.lead,
    theme: theme,
    containerContent: true,
    marginBottom: true
  }), react_1["default"].createElement(basic_frontend_common_1.ContainerSection, {
    theme: theme,
    marginBottom: true,
    paddingBottom: true
  }, react_1["default"].createElement(basic_frontend_common_1.TextRegular, {
    theme: theme,
    paddingBottom: true
  }, localizedStrings.sharedContent.pages.pageAbout.paragraphOne), react_1["default"].createElement("ul", {
    className: "w-full"
  }, react_1["default"].createElement("li", {
    className: "flex flex-row content-center items-center w-full mt-4"
  }, react_1["default"].createElement(basic_frontend_common_1.Icon, {
    name: "external_link_arrow_right",
    size: basic_frontend_common_1.IconSize.xxxs,
    className: "flex mr-2 mb-1"
  }), react_1["default"].createElement(basic_frontend_common_1.Link, {
    theme: theme,
    href: localizedStrings.sharedContent.pages.pageAbout.linkPwa,
    newWindow: true
  }, localizedStrings.sharedContent.pages.pageAbout.LinkPwaText)), react_1["default"].createElement("li", {
    className: "flex flex-row content-center items-center w-full mt-4"
  }, react_1["default"].createElement(basic_frontend_common_1.Icon, {
    name: "external_link_arrow_right",
    size: basic_frontend_common_1.IconSize.xxxs,
    className: "flex mr-2 mb-1"
  }), react_1["default"].createElement(basic_frontend_common_1.Link, {
    theme: theme,
    href: localizedStrings.sharedContent.pages.pageAbout.linkWeb,
    newWindow: true
  }, localizedStrings.sharedContent.pages.pageAbout.LinkWebText))), react_1["default"].createElement(basic_frontend_common_1.TextRegular, {
    theme: theme,
    paddingTop: true,
    paddingBottom: true
  }, localizedStrings.sharedContent.pages.pageAbout.paragraphFour)), react_1["default"].createElement(basic_frontend_common_1.ContainerSection, {
    theme: theme,
    marginBottom: true,
    paddingBottom: true
  }, react_1["default"].createElement(basic_frontend_common_1.CallToAction, {
    ctaHeader: localizedStrings.sharedContent.pages.pageAbout.ctaHeader_2,
    ctaText: localizedStrings.sharedContent.pages.pageAbout.ctaText_2,
    primaryButtonText: localizedStrings.sharedContent.pages.pageAbout.primaryButtonText_2,
    primaryButtonAction: "/disclaimer",
    primaryButtonType: basic_frontend_common_1.ButtonType.secondary,
    secondaryButtonText: localizedStrings.sharedContent.pages.pageAbout.secondaryButtonText_2,
    secondaryButtonAction: "/contact",
    secondaryButtonType: basic_frontend_common_1.ButtonType.tertiary,
    theme: theme
  })), react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(basic_frontend_common_1.Spacer, null), react_1["default"].createElement(basic_frontend_common_1.ToTopLink, null), react_1["default"].createElement(basic_frontend_common_1.Spacer, null)));
};

exports.PageAbout = PageAbout;